import { Sidebar, StarCircled } from '@weareopenr/component-library';
import { type IAccordionProps } from '@weareopenr/component-library/build/components/Accordion/types';
import { usePermissions } from 'src/hooks';

interface IAdminAppSidebar {
  open: boolean;
  appName: string;
  currentPath: string;
  onSidebarClick: () => void;
}

const AdminAppSidebar = ({ open, appName, currentPath, onSidebarClick }: IAdminAppSidebar) => {
  const { canViewUsersAndRoles } = usePermissions();
  const sidebarContent: Omit<IAccordionProps, 'currentPath'>[] | undefined = canViewUsersAndRoles
    ? [
        {
          title: 'Access Control',
          IconComponent: StarCircled,
          content: [
            {
              label: 'Users',
              path: '/users',
            },
            {
              label: 'Roles',
              path: '/roles',
            },
          ],
        },
      ]
    : undefined;

  return (
    <Sidebar
      open={open}
      appName={appName}
      homeLinks={[
        {
          title: 'Brands',
          path: '/',
          IconComponent: StarCircled,
        },
      ]}
      sidebarContent={sidebarContent}
      currentPath={currentPath}
      onSidebarClick={onSidebarClick}
    />
  );
};

export default AdminAppSidebar;
